<template>
  <div v-if="userPermission">
    <div v-if="!loading">
      <b-form>
        <div>
          <b-tabs no-nav-style nav-class="secondary-tabs">
            <b-tab
              :title="$t('tabs.general')"
              class="p-5"
              @click.prevent="updateVisibleSubmit(true)"
            >
              <taxes-form />
            </b-tab>
            <edit-actions
              route-name="taxesList"
              :is-visible-submit="isVisibleSubmit"
              @save="submit"
            />
          </b-tabs>
        </div>
      </b-form>
    </div>
    <div v-else>
      <spinner />
    </div>
  </div>
  <div
    v-else
    class="w-100 h-100 d-flex align-items-center justify-content-center"
  >
    <p class="fs-18 font-weight-bold">
      {{ $t("messages.dont_have_permission") }}
    </p>
  </div>
</template>

<script>
import taxesForm from '@/components/taxes/form'
import editActions from '@/components/common/editActions'
import model from '@/models/taxes'
import edit from '@/mixins/edit'
import permissions from '@/mixins/permissions'
import api from '@/api/taxes'

export default {
  components: {
    taxesForm,
    editActions
  },
  mixins: [edit, permissions],
  data: () => ({
    api,
    loading: true,
    model: JSON.parse(JSON.stringify(model.empty)),
    rules: model.rules,
    isVisibleSubmit: true
  }),
  created() {
    this.init()
  },
  methods: {
    async init() {
      if (this.$route.params.id) {
        await this.getItem()
      } else {
        this.initForm(this.model)
      }
      this.loading = false
    },
    updateVisibleSubmit(value) {
      this.isVisibleSubmit = value
    }
  },
  validations: {
    ...model.rules
  }
}
</script>

